import { render, staticRenderFns } from "./PricelistOld.vue?vue&type=template&id=9cdf431a&scoped=true&"
import script from "./PricelistOld.vue?vue&type=script&lang=js&"
export * from "./PricelistOld.vue?vue&type=script&lang=js&"
import style0 from "./PricelistOld.vue?vue&type=style&index=0&id=9cdf431a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdf431a",
  null
  
)

export default component.exports